// src/components/AudioUnlocker/AudioUnlocker.tsx
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useEffect, useState } from "react";
import silence from '../../assets/silence.mp3';
const AudioUnlocker = () => {
    const [isUnlocked, setIsUnlocked] = useState(false);
    useEffect(() => {
        if (isUnlocked) {
            return;
        }
        const unlockAudio = () => __awaiter(void 0, void 0, void 0, function* () {
            // 1. Разблокировка через Web Audio API (для большинства браузеров)
            const audioContext = new (window.AudioContext || window.AudioContext)();
            if (audioContext.state === "suspended") {
                yield audioContext.resume();
            }
            // 2. Ключевой шаг для iOS: воспроизводим тишину
            const audio = new Audio(silence); // Путь к вашему файлу
            try {
                // Play() возвращает Promise. Мы должны его обработать.
                yield audio.play();
                // Если мы дошли до сюда - звук разблокирован
                console.log("Audio unlocked successfully!");
                setIsUnlocked(true);
            }
            catch (error) {
                console.error("Failed to unlock audio:", error);
                // Ошибка может возникнуть, если пользователь еще не взаимодействовал со страницей
            }
        });
        // Используем 'touchend' - это самое надежное событие для iOS
        // 'click' добавляем для совместимости с десктопом
        document.addEventListener("touchend", unlockAudio, { once: true });
        document.addEventListener("click", unlockAudio, { once: true });
        return () => {
            // Очистка на случай, если компонент размонтируется
            document.removeEventListener("touchend", unlockAudio);
            document.removeEventListener("click", unlockAudio);
        };
    }, [isUnlocked]);
    // Этот компонент ничего не рендерит
    return null;
};
export default AudioUnlocker;
